module.exports = __webpack_public_path__ + "img/topbg.7d4dbb5c.png";